module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/home/home.component.scss
// module id = ./src/app/entities/home/home.component.scss
// module chunks = main